class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // ESC key closes the disclosure and restores focus to the trigger
    this.mainDetailsToggle.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.close();
      this.mainDetailsToggle.querySelector('summary').focus();
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.mainDetailsToggle.addEventListener('mouseenter', this.openMenu.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.close.bind(this));
  }

  onToggle() {
    if (!this.header) return;

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.header.classList.add('open_submenu');
    } else {
      this.header.classList.remove('open_submenu');
    }

    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  openMenu() {
    console.log(this.mainDetailsToggle);
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.header.classList.add('open_submenu');
    if (!document.querySelector(".header-index")) return;
    this.header.classList.remove('make-header-white');
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    if (this.header.classList.contains('open_submenu')) {
      this.header.classList.remove('open_submenu');
      if (!document.querySelector(".header-index")) return;
      this.header.classList.add('make-header-white');
    }
  }
}

customElements.define('header-menu', HeaderMenu);
